import { useEffect } from "react";

/**
 * Name the tab.
 *
 * `SeoMeta` does this for the seven routes that carry catalogue SEO, but nine
 * others — the basket, checkout, sign-in, the account, the shop listing — had
 * no title of their own and inherited whatever the index.html default said.
 * That made them indistinguishable in a tab strip, in history, and in a
 * bookmark, which is the one place a customer looks for "the checkout I had
 * open". A hook rather than a component because several of these pages render
 * more than one root branch (loading, error, content) and a JSX element would
 * have to be repeated in each.
 */
const SITE = "Atelier Di Falco";

export function useDocumentTitle(title) {
  useEffect(() => {
    const name = String(title || "").trim();
    document.title = !name
      ? SITE
      : name.toLocaleLowerCase().includes(SITE.toLocaleLowerCase())
        ? name
        : `${name} | ${SITE}`;
  }, [title]);
}

export default useDocumentTitle;
